import React, { useState } from "react";  // removed useEffect since it's not used
import { Helmet } from "react-helmet";
import RobotSelection from "../Common/RobotSelection";
import FolderSelection from "../Common/FolderSelection";
import "../../styles/Triggers.css";
import ProcessSelection from "../Common/ProcessSelection";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import LoggingService from "../../services/LoggingService";
import { useTenant } from "../../context/TenantContext";
import config from '../../config/config';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const LinkedTaskTrigger = () => {
  const { selectedTenant } = useTenant();
  const [completedProcess, setCompletedProcess] = useState({ id: "", dbId: "", name: "" });
  const [name, setName] = useState("");
  const [nextProcess, setNextProcess] = useState({ id: "", dbId: "", name: "" });
  const [robot, setRobot] = useState("All");
  const [folder, setFolder] = useState("");
  const navigate = useNavigate();
  const [argumentsList, setArgumentsList] = useState([]);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [priority, setPriority] = useState('Inherited');
  const [stickToRobot, setStickToRobot] = useState(false);

  const priorities = [
    { value: "Inherited", label: "Inherited", icon: "○" },
    { value: "Critical", label: "Critical", icon: "◊" },
    { value: "Highest", label: "Highest", icon: "≫" },
    { value: "Very high", label: "Very high", icon: "≫" },
    { value: "High", label: "High", icon: "∧" },
    { value: "Medium-high", label: "Medium-high", icon: "⋀" },
    { value: "Medium", label: "Medium", icon: "=" },
    { value: "Medium-low", label: "Medium-low", icon: "⋁" },
    { value: "Low", label: "Low", icon: "∨" },
    { value: "Very low", label: "Very low", icon: "≪" },
    { value: "Lowest", label: "Lowest", icon: "≪" }
  ];

  const validateForm = () => {
    const newErrors = {};

    if (!name.trim()) {
      newErrors.name = "Trigger Name is required";
    }

    if (!completedProcess.id) {
      newErrors.completedProcess = "Completed Process is required";
    }

    if (!nextProcess.id) {
      newErrors.nextProcess = "Next Process is required";
    }

    if (completedProcess.id && nextProcess.id && completedProcess.id === nextProcess.id) {
      newErrors.nextProcess = "Next Process cannot be the same as Completed Process";
      toast.error("Next Process cannot be the same as Completed Process");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleLinkedTaskTrigger = async () => {
    setIsSubmitting(true);

    if (!validateForm()) {
      setIsSubmitting(false);
      return;
    }

    const userId = localStorage.getItem("userId");
    if (!userId) {
      return;
    }

    if (!selectedTenant) {
      console.error("No tenant selected");
      return;
    }

    // const payload = {
    //   name,
    //   status: "Active",
    //   createdBy: userId,
    //   completedProcess: {
    //     id: completedProcess.id,  // Just use the id directly
    //     name: completedProcess.name
    //   },
    //   nextProcess: {
    //     id: nextProcess.id,  // Just use the id directly
    //     name: nextProcess.name,
    //     argumentsList,
    //     stickto_robot: stickToRobot
    //   },
    //   robot,
    //   folderId: folder,
    //   priority: priority
    // };

    const payload = {
      name,
      status: "Active",
      createdBy: userId,
      completedProcess: {
        id: completedProcess.id,
        name: completedProcess.name
      },
      nextProcess: {
        id: nextProcess.id,
        name: nextProcess.name,
        stickto_robot: stickToRobot  // ✅ sadece bu kalsın burada
      },
      robot,
      folderId: folder,
      priority,
      argumentsList // ✅ buraya çıkart
    };


    try {
      const token = localStorage.getItem("userToken");
      const response = await axios.post(
        `${config.API_BASE_URL}/api/linkedtaskTrigger`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'X-UIPATH-OrganizationUnitId': selectedTenant.id
          }
        }
      );

      toast.success("Linked Task Trigger created successfully!");
      console.log("Linked Task Trigger created:", response.data);
      navigate("/dashboard");
      setErrors({});
    } catch (error) {
      setIsSubmitting(false);
      toast.error("Failed to create trigger. Please try again.");
      console.error("Error details:", {
        response: error.response?.data,
        status: error.response?.status,
        payload: payload
      });
      setErrors({ submit: "Failed to create trigger. Please try again." });
    }
  };

  return (
    <div className="trigger-container">
      <Helmet>
        <title>Create Linked Task Trigger</title>
      </Helmet>
      <h2>Linked Task Trigger</h2>

      {!selectedTenant ? (
        <p className="error-message">Please select a tenant first.</p>
      ) : (
        <>
          <div className="form-group">
            <label>Trigger Name *</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter Trigger Name"
              className={errors.name ? "error" : ""}
            />
            {errors.name && <span className="error-message">{errors.name}</span>}
          </div>

          <FolderSelection
            folder={folder}
            onChange={setFolder}
            isGlobal={true}
          />
          <RobotSelection
            robot={robot}
            onChange={setRobot}
            folder={folder}
          />

          <ProcessSelection
            process={completedProcess}
            onChange={setCompletedProcess}
            label="Completed Process *"
            folder={folder}
            error={errors.completedProcess}
          />

          <ProcessSelection
            process={nextProcess}
            onChange={(selected) => {
              if (selected && selected.id === completedProcess.id) {
                toast.error("You cannot select the same process for both steps");
                return;
              }
              setNextProcess({
                id: selected?.id || "",
                name: selected?.name || ""
              });
              setArgumentsList([]); // Reset arguments when process changes
            }}
            label="Next Process *"
            folder={folder}
            disabledProcess={completedProcess.id}
            error={errors.nextProcess}
          />

          <div className="form-group process-robot-lock">
            <div className="robot-lock-container">
              <input
                type="checkbox"
                id="stickToRobot"
                checked={stickToRobot}
                onChange={(e) => setStickToRobot(e.target.checked)}
                disabled={robot === 'All'}
              />
              <label htmlFor="stickToRobot" className="robot-lock-label">
                <span className="lock-icon">🔒</span>
                Lock next process to selected robot
              </label>
            </div>
            {robot === 'All' ? (
              <small className="help-text warning">
                Select a specific robot to enable process locking
              </small>
            ) : (
              <small className="help-text">
                The next process will only be executed by the selected robot
              </small>
            )}
          </div>

          {nextProcess.id && (
            <div className="form-group">
              <label>Input Arguments for Next Process</label>
              <button
                onClick={() => setArgumentsList([...argumentsList, { name: "", value: "" }])}
                type="button"
              >
                Add Argument
              </button>
              {argumentsList.map((arg, index) => (
                <div key={index} className="argument">
                  <input
                    type="text"
                    value={arg.name}
                    onChange={(e) => setArgumentsList(argumentsList.map((a, i) =>
                      i === index ? { ...a, name: e.target.value } : a
                    ))}
                    placeholder="Argument Name"
                  />
                  <input
                    type="text"
                    value={arg.value}
                    onChange={(e) => setArgumentsList(argumentsList.map((a, i) =>
                      i === index ? { ...a, value: e.target.value } : a
                    ))}
                    placeholder="Argument Value"
                  />
                  <button
                    onClick={() => setArgumentsList(argumentsList.filter((_, i) => i !== index))}
                    type="button"
                  >
                    Remove
                  </button>
                </div>
              ))}
            </div>
          )}

          {errors.submit && <div className="submit-error">{errors.submit}</div>}


          <div className="form-group">
            <label>Job Priority</label>
            <select
              value={priority}
              onChange={(e) => setPriority(e.target.value)}
              className="form-control"
            >
              {priorities.map((p) => (
                <option key={p.value} value={p.value}>
                  {p.icon} {p.label}
                </option>
              ))}
            </select>
          </div>
          <button
            onClick={handleLinkedTaskTrigger}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Saving..." : "Save Trigger"}
          </button>
        </>
      )}
    </div>
  );
};

export default LinkedTaskTrigger;